import {$} from "./util";
import Sketch from "sketch-js";
import "./perlin";

(function () {
    const container = $('.js-avatar');
    if (!container) return;


    const imageUrl = window.PW.config.avatarImage;
    if (!imageUrl) return;

    const luma = (R, G, B) => (R + R + R + B + G + G + G + G) >> 3;

    Sketch.create({
        spacing: 10,
        minLuminance: 40,
        minSize: 3,
        sizeVariance: 4,
        keydown() {
            if (!(this.keys.R && this.keys.SHIFT)) return;
            this.resize();
        },
        resize() {
            this.clear();
            this.setup();
        },
        setup() {
            this.container.classList.remove('fade-in');
            this.fillStyle = '#222';
            this.fillRect(0, 0, this.width, this.height);
            this.np0 = random();
            this.ns0 = random();

            this.stop();
            this.loadImage(() => {
                this.preparePoints();
                this.clear();
                this.start();
            });
        },
        loadImage(cb) {
            let img = new Image();
            img.crossOrigin = 'anonymous';
            img.onload = () => {
                let w = img.width,
                    h = img.height,
                    r = w / h,
                    adjW = round(r * this.height),
                    adjH = round(this.width / r),
                    x,
                    y;

                if (w >= h) {
                    // wide image
                    h = this.height;
                    w = adjW;
                } else {
                    // portrait image
                    w = this.width;
                    h = adjH;
                }
                x = this.width / 3 - w / 2;
                y = this.height / 2 - h / 2;

                if (this.width < 500) x = this.width / 4 - w / 2;

                this.drawImage(img, x, y, w, h);
                this.container.classList.add('fade-in');
                cb();
            };
            img.src = imageUrl;
        },
        preparePoints() {
            let surface = this.getImageData(0, 0, this.width, this.height);
            let step = this.spacing;

            this.points = [];
            for (let x = 0; x < this.width; x += step) {
                for (let y = 0; y < this.height; y += step) {
                    let i = y * this.width * 4 + (4 * x);

                    let r = surface.data[i],
                        g = surface.data[i + 1],
                        b = surface.data[i + 2],
                        a = surface.data[i + 3];

                    let l = luma(r, g, b);

                    if (l > this.minLuminance) {
                        let p = {
                            x: x,
                            y: y,
                            luma: l
                        };
                        this.points.push(p);
                    }
                }
            }
        },
        draw() {
            let ns0 = this.ns0 += 0.012;

            for (let i = 0; i < this.points.length; ++i) {
                let p = this.points[i];
                let ns = noise.perlin2(ns0 + p.x / this.width, p.y / this.height + ns0);
                this.fillStyle = `rgba(200,200,200, ${p.luma / 255})`;
                let size = ceil(p.luma / 255 * this.sizeVariance) * ns + this.minSize;
                this.drawRect(p.x, p.y, size);
            }
        },
        drawRect(x, y, size) {
            this.fillRect(x - size / 2, y - size / 2, size, size);
        },
        container: container,
        autoclear: true,
        autopause: true,
        autostart: false,
        interval: 2
    });
})();


// WEBPACK FOOTER //
// ./js/avatar.js